import React from 'react';
import { useSmall } from 'utils';
import {
  VehicleBannerActions,
  VehicleBannerContent,
  VehicleBannerLayout,
  VehicleBannerMobileActions,
  VehicleBannerWrapper,
} from './VehicleBanner.styled';

export const VehicleBanner = ({
  children,
  actions,
  isCompact,
}: {
  children: React.ReactNode;
  actions?: React.ReactNode;
  isCompact?: boolean;
}) => {
  const isSmall = useSmall();
  const inlineActions = !isSmall || isCompact;

  return (
    <VehicleBannerWrapper>
      <VehicleBannerLayout>
        <VehicleBannerContent>{children}</VehicleBannerContent>
        {inlineActions && actions && (
          <VehicleBannerActions data-testid={'vehicle-banner-inline-actions'}>{actions}</VehicleBannerActions>
        )}
        {!inlineActions && actions && (
          <VehicleBannerMobileActions data-testid={'vehicle-banner-mobile-actions'}>
            {actions}
          </VehicleBannerMobileActions>
        )}
      </VehicleBannerLayout>
    </VehicleBannerWrapper>
  );
};
